export const locationsActions = {

  FETCH_LOCATION_FAILED: 'FETCH_LOCATION_FAILED',
  FETCH_LOCATION_SUCCESS: 'FETCH_LOCATION_SUCCESS',
  FETCH_LOCATION_PENDING: 'FETCH_LOCATION_PENDING',
  LOAD_LOCATION: 'LOAD_LOCATION',

  fetchLocationsFailed: error => ({
    type: locationsActions.FETCH_LOCATION_FAILED,
    payload: error
  }),

  fetchLocationsSuccess: (id, {data}) => ({
    type: locationsActions.FETCH_LOCATION_SUCCESS,
    payload: {
      ...data,
      id: id
    }
  }),

  fetchLocationsPending: id => ({
    type: locationsActions.FETCH_LOCATION_PENDING,
    payload: {
      id
    }
  }),

  loadLocation: (locationId, sessionId) => ({
    type: locationsActions.LOAD_LOCATION,
    payload: {
      id: locationId,
      sessionId
    }
  }),
}

export const locationsRequestActions = {
  failed: locationsActions.fetchLocationsFailed,
  success: locationsActions.fetchLocationsSuccess,
  pending: locationsActions.fetchLocationsPending
};
